import { WithAuthenticationRequiredOptions, withAuthenticationRequired } from "@auth0/auth0-react";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

type AuthGuardProps = WithAuthenticationRequiredOptions & {
	component: React.ComponentType<object>;
};

export const AuthGuard = ({ component, ...args }: AuthGuardProps) => {
	const Component = withAuthenticationRequired(component, args);
	return <Component />;
};

type RBACAuthGuardProps = WithAuthenticationRequiredOptions & {
	roles: string[];
	rbacRedirectTo: string;
	component: React.ComponentType<object>;
};

export const RBACAuthGuard = ({
	roles,
	rbacRedirectTo,
	component,
	...args
}: RBACAuthGuardProps) => {
	const navigate = useNavigate();
	const { user } = useAuthenticatedUser();

	useEffect(() => {
		const userRoles = user.type === "admin" ? user.roles : [user.role];
		if (!roles.some((role) => userRoles.includes(role))) {
			navigate(rbacRedirectTo);
		}
	}, [user, roles, rbacRedirectTo, navigate]);

	const Component = withAuthenticationRequired(component, args);

	return <Component />;
};
